import { useState } from 'react';
import { useAuth } from '../../contexts/AuthContext';

const Profile = () => {
  const { currentUser } = useAuth();
  const [isEditing, setIsEditing] = useState(false);
  
  // Form state
  const [formData, setFormData] = useState({
    name: currentUser.name,
    email: currentUser.email,
    department: 'IT Security',
    jobTitle: 'Security Analyst',
    notificationPreferences: {
      email: true,
      browser: false,
    },
  });
  
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });
  };
  
  const handleCheckboxChange = (e) => {
    const { name, checked } = e.target;
    setFormData({
      ...formData,
      notificationPreferences: {
        ...formData.notificationPreferences,
        [name]: checked,
      },
    });
  };
  
  const handleSubmit = (e) => {
    e.preventDefault();
    // Here we would typically call an API to update the user profile
    // For demo purposes, we'll just toggle the edit mode
    setIsEditing(false);
    
    // Display a success message
    alert('Profile updated successfully!');
  };
  
  return (
    <div>
      <h1 className="text-2xl font-bold text-gray-900 mb-6">
        Your Profile
      </h1>
      
      <div className="card mb-6">
        <div className="flex justify-between items-center mb-6">
          <h2 className="text-lg font-semibold text-gray-900">Personal Information</h2>
          {!isEditing && (
            <button 
              onClick={() => setIsEditing(true)}
              className="btn btn-outline"
            >
              Edit Profile
            </button>
          )}
        </div>
        
        {isEditing ? (
          <form onSubmit={handleSubmit}>
            <div className="grid grid-cols-1 gap-6 md:grid-cols-2">
              <div>
                <label htmlFor="name" className="block text-sm font-medium text-gray-700 mb-1">
                  Full Name
                </label>
                <input
                  type="text"
                  id="name"
                  name="name"
                  value={formData.name}
                  onChange={handleChange}
                  className="input"
                  required
                />
              </div>
              
              <div>
                <label htmlFor="email" className="block text-sm font-medium text-gray-700 mb-1">
                  Email Address
                </label>
                <input
                  type="email"
                  id="email"
                  name="email"
                  value={formData.email}
                  onChange={handleChange}
                  className="input"
                  required
                />
              </div>
              
              <div>
                <label htmlFor="department" className="block text-sm font-medium text-gray-700 mb-1">
                  Department
                </label>
                <input
                  type="text"
                  id="department"
                  name="department"
                  value={formData.department}
                  onChange={handleChange}
                  className="input"
                />
              </div>
              
              <div>
                <label htmlFor="jobTitle" className="block text-sm font-medium text-gray-700 mb-1">
                  Job Title
                </label>
                <input
                  type="text"
                  id="jobTitle"
                  name="jobTitle"
                  value={formData.jobTitle}
                  onChange={handleChange}
                  className="input"
                />
              </div>
            </div>
            
            <div className="mt-6">
              <h3 className="text-md font-medium text-gray-700 mb-2">Notification Preferences</h3>
              
              <div className="space-y-2">
                <div className="flex items-center">
                  <input
                    type="checkbox"
                    id="email-notifications"
                    name="email"
                    checked={formData.notificationPreferences.email}
                    onChange={handleCheckboxChange}
                    className="h-4 w-4 text-primary-600 border-gray-300 rounded"
                  />
                  <label htmlFor="email-notifications" className="ml-2 block text-sm text-gray-700">
                    Email Notifications
                  </label>
                </div>
                
                <div className="flex items-center">
                  <input
                    type="checkbox"
                    id="browser-notifications"
                    name="browser"
                    checked={formData.notificationPreferences.browser}
                    onChange={handleCheckboxChange}
                    className="h-4 w-4 text-primary-600 border-gray-300 rounded"
                  />
                  <label htmlFor="browser-notifications" className="ml-2 block text-sm text-gray-700">
                    Browser Notifications
                  </label>
                </div>
              </div>
            </div>
            
            <div className="mt-6 flex space-x-3">
              <button
                type="submit"
                className="btn btn-primary"
              >
                Save Changes
              </button>
              <button
                type="button"
                onClick={() => setIsEditing(false)}
                className="btn btn-outline"
              >
                Cancel
              </button>
            </div>
          </form>
        ) : (
          <div className="grid grid-cols-1 gap-4 md:grid-cols-2">
            <div>
              <p className="text-sm font-medium text-gray-500">Full Name</p>
              <p className="mt-1">{formData.name}</p>
            </div>
            
            <div>
              <p className="text-sm font-medium text-gray-500">Email Address</p>
              <p className="mt-1">{formData.email}</p>
            </div>
            
            <div>
              <p className="text-sm font-medium text-gray-500">Department</p>
              <p className="mt-1">{formData.department}</p>
            </div>
            
            <div>
              <p className="text-sm font-medium text-gray-500">Job Title</p>
              <p className="mt-1">{formData.jobTitle}</p>
            </div>
            
            <div className="md:col-span-2">
              <p className="text-sm font-medium text-gray-500">Notification Preferences</p>
              <p className="mt-1">
                {formData.notificationPreferences.email ? 'Email notifications enabled' : 'Email notifications disabled'}
                {', '}
                {formData.notificationPreferences.browser ? 'Browser notifications enabled' : 'Browser notifications disabled'}
              </p>
            </div>
          </div>
        )}
      </div>
      
      <div className="card">
        <h2 className="text-lg font-semibold text-gray-900 mb-4">Security</h2>
        
        <div>
          <button className="btn btn-outline mb-4">
            Change Password
          </button>
          
          <p className="text-sm text-gray-500">
            Last login: October 18, 2023 at 09:45 AM
          </p>
        </div>
      </div>
    </div>
  );
};

export default Profile; 